import type { Page } from '../../types';

const civilCostAwards: Page[] = [
  {
    pageType: 'question',
    title: 'Civil cost awards',
    name: 'civil-cost-awards-declare',
    questions: [
      {
        questionType: 'radio',
        title: 'Do you have any instances of civil cost awards to declare?',
        name: 'costs_awards_civil_declare',
        options: ['Yes', 'No'],
        rules: { required: true },
      },
    ],
  },
  {
    pageType: 'question',
    title: 'Civil cost awards',
    name: 'civil-cost-awards',
    type: 'nilreturn',
    fastToggle: true,
    total: {
      columns: [
        { title: 'Number of instances', field: 'costs_awards_civil_instances' },
        { title: 'Total Value', field: 'costs_awards_civil' },
      ],
    },
    disabled: [
      {
        field: 'costs_awards_civil_declare',
        condition: 'equals',
        value: 'No',
      },
    ],
    questions: [
      {
        questionType: 'instanceInput',
        title: 'Total number of instances',
        name: 'costs_awards_civil_instances',
        hint: '',
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'costInput',
        displaySeperator: 'thousand',
        title: 'Estimated total value',
        name: 'costs_awards_civil',
        hint: '',
        rules: {
          required: true,
          decimal: 'decimal(2)',
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments',
        hideOptionalLabel: true,
        name: 'costs_awards_civil_comments',
        hint: 'Please ensure you do not include any personal or sensitive information',
        rules: {
          required: false,
        },
      },
    ],
  },
];
export default civilCostAwards;




